module.exports = __webpack_public_path__ + "assets/img/microsoft-luis.5367361d.png";